import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import RoomForm from '@/pages/dashboard/rooms/components/RoomForm';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/lib/supabase';

function RoomNew() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [businessId, setBusinessId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!user) return;
      const { data } = await supabase
        .from('businesses')
        .select('id')
        .eq('owner_id', user.id)
        .maybeSingle();
      if (mounted) {
        setBusinessId(data?.id ?? null);
        setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [user]);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center py-20">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10">
            <i className="ri-loader-4-line text-2xl text-primary-400 animate-spin" />
          </div>
        </div>
      </DashboardLayout>
    );
  }

  if (!businessId) {
    return (
      <DashboardLayout>
        <div className="max-w-xl mx-auto text-center py-16">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-500/10">
            <i className="ri-store-2-line text-3xl text-primary-400" />
          </div>
          <h1 className="font-heading font-bold text-2xl text-foreground-50 mb-2">Entreprise requise</h1>
          <p className="text-sm text-foreground-400 mb-6">
            Vous devez d&apos;abord inscrire votre entreprise avant d&apos;ajouter des chambres.
          </p>
          <Link
            to="/auth/register"
            className="inline-block px-6 py-2.5 bg-primary-500 text-foreground-950 font-semibold rounded-lg hover:bg-primary-400 transition-colors text-sm"
          >
            Inscrire mon entreprise
          </Link>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Ajouter une chambre</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Renseignez le nom, le prix par nuit et les équipements de votre chambre.
        </p>
      </div>

      <div className="max-w-3xl">
        <RoomForm
          businessId={businessId}
          ownerId={user!.id}
          onSaved={() => navigate('/dashboard/rooms')}
        />
      </div>
    </DashboardLayout>
  );
}

export default RoomNew;